import { useState, useEffect } from "react";
import Help from "./Help";
import Helpers from "./helpers";

Object.byString = function (o, s) {
  if (!o || !s) return;
  s = s.replace(/\[(\w+)\]/g, ".$1");
  s = s.replace(/^\./, "");
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

function coerceSelectValue(raw) {
  if (raw === "" || raw == null) return "";
  const asNum = Number(raw);
  return Number.isNaN(asNum) ? raw : asNum;
}

export default function FormSelect(props) {
  const label =
    props.label || props.field || (props.labelProp ? props.options?.[0]?.[props.labelProp] : "");
  const field =
    props.field || props.label || (props.valueProp ? props.options?.[0]?.[props.valueProp] : "");
  const [currentValue, setCurrentValue] = useState(() => {
    const fromObj = props.formObject?.object?.[field];
    return fromObj == null || fromObj === "" ? "" : fromObj;
  });
  const [id] = useState(Helpers.uuidv4());

  useEffect(() => {
    const fromObj = props.formObject?.object?.[field];
    setCurrentValue(fromObj == null || fromObj === "" ? "" : fromObj);
  }, [props.formObject?.object, field, props.formObject?.object?.[field]]);

  if (!label) {
    console.error("FormSelect requires a field or label property");
  }
  if (!field) {
    console.error("FormSelect requires a field property");
  }
  if (!props.options) {
    console.warn(
      "FormSelect(" + label + ") requires a valid option parameter from which to create the dropdown values"
    );
  }

  if (!props.formObject || !props.formObject.object) {
    console.error("FormSelect(" + label + ") did not properly set the formObject on the FormSelect");
  } else if (!props.formObject.object.hasOwnProperty(props.field)) {
    console.warn("The form's object does not have a property named " + field);
  }
  if (!props.formObject?.hasOwnProperty("onChange")) {
    console.error(
      "FormSelect(" +
        label +
        ") requires an onChange property defined on the component level because it returns the whole object not just the ID"
    );
  }
  if (props.options && props.options.length > 0) {
    if (
      !props.options[0].hasOwnProperty(props.valueProp) ||
      !props.options[0].hasOwnProperty(props.labelProp)
    ) {
      console.error(
        "FormSelect(" +
          props.label +
          ") options do not have a value(" +
          props.valueProp +
          ") or label(" +
          props.labelProp +
          ") property. The object has the following properties (" +
          Helpers.getObjectPropertyNames(props.options[0]).join(",") +
          ")."
      );
    }
  }

  const values = (props.options || []).map((c) => ({
    Key: c[props.valueProp],
    Value: c[props.labelProp],
  }));

  const seenKeys = new Set();
  values.forEach((item) => {
    if (seenKeys.has(item.Key)) {
      console.error("Duplicate Key value found: " + item.Key);
    } else {
      seenKeys.add(item.Key);
    }
  });

  function onNativeChange(e) {
    const raw = e.target.value;
    const coerced = coerceSelectValue(raw);
    setCurrentValue(coerced === "" ? "" : coerced);

    const selected = (props.options || []).find(
      (o) => String(o[props.valueProp]) === String(raw)
    );

    if (props.onChange) {
      // Prefer scalar id/value for most callers; Location handlers accept either.
      props.onChange(coerced, field, "FormSelect", e, selected);
    } else if (props.formObject?.onChange) {
      props.formObject.onChange(coerced, field, "FormSelect", e);
      if (props.nameField && selected) {
        props.formObject.onChange(
          selected[props.labelProp],
          props.nameField,
          "FormSelect",
          e
        );
      }
    }
  }

  function onFocus(e) {
    props.onOpen?.(e);
  }

  return (
    <div
      className={`field FormSelect form-group${props.className ? ` ${props.className}` : ""}`}
      hidden={props.hidden || undefined}
    >
      {label ? (
        <label htmlFor={id}>
          {label}
          {props.helpid ? <Help id={props.helpid} /> : null}
        </label>
      ) : null}
      <select
        style={{ minWidth: 180 }}
        value={currentValue === null || currentValue === undefined ? "" : currentValue}
        onChange={onNativeChange}
        onFocus={onFocus}
        id={id}
        data-field={field}
      >
        <option value="">Select…</option>
        {values.map((c) => (
          <option key={String(c.Key)} value={c.Key}>
            {c.Value}
          </option>
        ))}
      </select>
    </div>
  );
}
